// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qw-2";
export var chatLink = "_qw-0";
export var chatText = "_qw-1";